import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";
import WGRTable from "./iohTable";


//import WGRTotals from "./iohTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
   const totals = useMemo(() => {
    return rows.reduce(
      (total, row) => ({
        trolly:
          total.trolly +
          Number(row.nooftrolly || 0),

        coachset:
          total.coachset +
          Number(row.coachset || 0),

           labourcost:
          total.labourcost +
          Number(row.labourcost || 0),

        materialcost:
          total.materialcost +
          Number(row.materialcost || 0),
        totalcost:
          total.totalcost +
          Number(row.totalcost || 0),

         }),

        
          

      {
        trolly: 0,
        coachset: 0,
        labourcost: 0,
        materialcost: 0,
        totalcost: 0,
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt:5,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
        >
          Railway  : {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

     

      {/* Shop Total */}
 {/* THIS IS WHERE WGRTable SHOULD BE */}
   <WGRTable
  rows={rows}
  shop={shop}
  totals={totals}
  showTotal={true}
/>
      
        
    </Paper>
  );
}

